import React from 'react';
import NavbarInv from '../../../components/navbarInv';
import FormularioDefinicionServicioBen from '../../../formDataInv/formularioDefinicionServicioBen';

function BeneficiarioDefinicionServicio() {
  return (
    <div className='flex flex-col h-auto'>
      {/* <NavbarInv /> */}
      <FormularioDefinicionServicioBen />
    </div>
  )
}

export default BeneficiarioDefinicionServicio;
